module.exports = __webpack_public_path__ + "img/president.f2ed29d4.jpg";